import Badge from '@splunk/react-ui/Badge';
import { variables } from '@splunk/themes';
import styled from 'styled-components';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';

export default function DashboardBetaBadge() {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledBadge backgroundColor={variables.notificationColorInfoWeak} label="Beta" />
        </ThemeProvider>
    );
}

const StyledBadge = styled(Badge)`
    margin-inline: ${variables.spacingSmall};
`;
